export default __webpack_public_path__ + "static/media/barcode.1cc9bdd8.svg";